// extracted by mini-css-extract-plugin
export var actions = "Hero-module--actions--4eee5";
export var btn = "Hero-module--btn--21c64";
export var btnOutlinePrimary = "Hero-module--btn-outline-primary--3b98c";
export var btnPrimary = "Hero-module--btn-primary--57315";
export var content = "Hero-module--content--d6a92";
export var formSelect = "Hero-module--form-select--93b01";
export var hero = "Hero-module--hero--00da1";
export var inner = "Hero-module--inner--0ea45";
export var media = "Hero-module--media--98bc7";
export var subtitle = "Hero-module--subtitle--27488";
export var title = "Hero-module--title--e18f6";